/* @flow */
import PaymentAccountActions from 'payments/actions/PaymentAccountActions';
import PaymentAccountStore from 'payments/stores/PaymentAccountStore';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const RequirePaymentAccount = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
      if (PaymentAccountStore.getPaymentAccount()) {
        callback();
      } else {
        PaymentAccountActions.load()
          .then(() => callback())
          .catch(err => console.error('Payment account load failure', err));
      }
    },
  },
};

export default RequirePaymentAccount;



// WEBPACK FOOTER //
// ./src/components/mixins/RequirePaymentAccount.js